/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import React from 'react';

import { SvgIcon } from '@mui/material';

export function XingIcon(props: React.ComponentProps<typeof SvgIcon>) {
  return (
    <SvgIcon {...props}>
      <path d="M14.947,24 L9.623,14.333 L17.693,0 L22.626,0 L14.557,14.333 L19.827,24 L14.947,24 L14.947,24 Z M7.656,5 L2.717,5 L5.485,9.744 L1.37,17 L6.284,17 L10.401,9.729 L7.656,5 Z" />
    </SvgIcon>
  );
}
